<template>
  <div class="flex flex-col gap-2 mt-4 items-center">
    <!-- OTP Input (Centered) -->
    <div class="flex gap-2">
      <input
        v-for="(digit, index) in otpArray"
        :key="index"
        ref="otpInput"
        type="text"
        maxlength="1"
        class="w-10 h-10 text-center border border-gray-300 rounded focus:outline-none focus:ring focus:ring-purple-300"
        v-model="otpArray[index]"
        @input="moveToNext(index)"
      />
    </div>

    <!-- Countdown timer (below OTP) -->
    <div class="mt-2" v-if="OTPCountdown">
      <countdown
        :time="time"
        @start="handleCountdownStart"
        @end="handleCountdownEnd"
      >
        <template #default="props">
          <div class="text-sm text-gray-600">
            {{ props.seconds }} seconds left
          </div>
        </template>
      </countdown>
    </div>
  </div>
</template>

<script>
import VueCountdown from "@chenfengyuan/vue-countdown";
export default {
  props: {
    type: {
      type: String,
      default: "Register",
    },
    userCred: {
      type: String,
      default: "",
    },
    toActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      otpArray: ["", "", "", ""],
      time: 30000,
      OTPCountdown: false,
      countdownStarted: false,
    };
  },
  components: {
    countdown: VueCountdown,
  },
  watch: {
    otpArray: {
      handler() {
        this.$emit("set-otp", this.otpArray.join(""));
      },
      deep: true,
    },
  },
  methods: {
    moveToNext(index) {
      if (this.otpArray[index] && index < this.otpArray.length - 1) {
        this.$refs.otpInput[index + 1].focus();
      }
    },
    async handleClick() {
      this.OTPCountdown = true;

      const payload = {
        type: this.type,
      };

      if (/^\d{10}$/.test(this.userCred)) {
        payload.mobile = this.userCred;
      } else if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.userCred)) {
        payload.email = this.userCred;
      }

      if (this.toActive) {
        payload.toActive = true;
      }

      try {
        const data = await this.$store.dispatch("auth/generateOTP", payload);
        if (data.code === 200) {
          this.$swal.fire({
            text: "OTP has been sent to your Email or Mobile",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
          });
        }
      } catch (error) {
        this.$swal.fire({
          title: "Error",
          text: error?.response?.data?.message || "Failed to send OTP",
          icon: "warning",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
        });
      }
    },
    handleCountdownStart() {
      this.countdownStarted = true;
      this.$emit("countdown-started", true);
    },
    handleCountdownEnd() {
      this.countdownStarted = false;
      this.OTPCountdown = false;
      this.$emit("countdown-started", false);
    },
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
